module.exports = __webpack_public_path__ + "static/consulting-d14806f1306c0379a98cfb3b3feceac2.jpeg";